import React, { useRef, useState, useEffect } from 'react';
import Payslip from "@/components/macro-organisms/tabs/consultants-vision-admin/payslib/payslip";
import usePayslipData from './usePayslipData';
import NewPayslipPanel from '@/components/macro-organisms/panels/panels-admin/NewPayslip/NewPayslipPanel';
import { usePayslips } from '@/services/consultant-services/query/usePayslips';
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';
import { useConsultantPayslips } from '@/services/admin-services/query/useConsultantPayslips';
import useUser from '@/services/admin-services/query/useUser';
import { useParams } from 'react-router-dom';
import InViewComponent from '@/components/organisms/InViewComponent';
import PrintEmptyDataMessage from '@/components/molecules/PrintEmptyDataMessage';
import MultiSelectorComponent, { ContentType } from "@/components/macro-organisms/tabs/MultiSelectorComponent";


export default function PayslipTab() {
    // const { payslips, error } = usePayslipData();
    const [payslipsCopy, setPayslipsCopy] = useState([]);
    const { loading, error, data, refetch } = useConsultantPayslips(1);
    const { id } = useParams();
    const { user: consultantUser } = useUser(id);
    const currentConsultantProfileUuid = consultantUser?.consultantProfile?.uuid;


    // gestion des slices :
    const [lastSlice, setLastSlice] = useState(1);
    // Requête initiale lors du changement d'ID
    useEffect(() => {
        refetchFromScratch();
    }, [id]);

    const refetchFromScratch = (n = 1) => {
        setLastSlice(n);
        setPayslipsCopy([]);
        refetch(n);
        console.log("refetch from Scratch")
    };
    const fetchNewSlice = () => {
        // console.log("fetchNewSlice", data?.hasNext, lastSlice)
        if (!loading && payslipsCopy.length > 0 && data?.hasNext) {
            setLastSlice((prevSlice) => prevSlice + 1);
        }
    };

    useEffect(() => {
        if (!loading && data) {
            if (lastSlice == 1) {
                setPayslipsCopy(() => [
                    ...data?.payslips
                ]);
            } else {
                setPayslipsCopy((prevPayslip) => [
                    ...prevPayslip,
                    ...data?.payslips
                ]);
            }
        }
        // console.log("payslips are :", data);
    }, [data]);


    return (
        // <>payslip tab for admin</>
        <div className="flex flex-col  gap-secondDegree overflow-auto pb-secondDegree px-1 items-center">
            <div className="flex gap-secondDegree w-full justify-end">
                <NewPayslipPanel global={false} refetchFromScratch={refetchFromScratch} />
            </div>
            {error && <PrintErrorMessage error={error} />}
            {loading && <span className='loader  my-4' />}
            {(!error && !loading) && payslipsCopy?.map((item, index) => (
                <MultiSelectorComponent
                    key={item.uuid}
                    idOfContent={item.uuid}
                    typeOfContent={ContentType.PAYSLIP}
                    idConsultant={id}
                >
                    <Payslip
                        key={index}
                        data={item}
                        dataOwner
                        currentConsultantProfileUuid={currentConsultantProfileUuid}
                        refetchFromScratch={refetchFromScratch}
                        editable
                    />
                </MultiSelectorComponent>

            ))}
            {!error && !loading &&
                payslipsCopy?.length == 0 &&
                <PrintEmptyDataMessage message="error.emptyDataPayslip" />}
            <InViewComponent inView={fetchNewSlice} />

        </div>
    )
}
